$(function()
{
	/*
	// Only allow number input
	$(el('edtVoucherValue')).on('keydown', function(e) {
		const iValue = $(this).val();
		const isVoucherInWishlist = $(this).closest('.wishlistWrapper').length > 0;
		const key = e.keyCode;

		// Always allow backspace
		if (key === 8) return;

		// If it's a voucher field, allow digits and decimal keys
		if (isVoucherInWishlist) {
			const isDigit = (key >= 48 && key <= 57) || (key >= 96 && key <= 105);
			const isDot = key === 110 || key === 190;

			// Only allow one dot
			if (isDot && !iValue.includes('.')) return;

			if (isDigit) return;

			// Prevent everything else
			e.preventDefault();
			return;
		}

		// Regular logic for non-wishlist voucher fields
		if ((isNaturalNumber(iValue) || iValue === '') &&
			![69, 109, 189, 107].includes(key)) {
			return;
		}

		e.preventDefault();
	});


	// Touch-friendly update preview
	$(el('edtVoucherValue')).on('input change', function () {
		const $this = $(this);
		const isWishlist = $this.closest('.wishlistWrapper').length > 0;
		const maxAttr = parseFloat($this.attr('max'));
		const maxValue = Number.isFinite(maxAttr) ? maxAttr : 9999;

		// get string
		let s = ($this.val() ?? '').toString();

		// normalize: comma -> dot, strip non-digits/dots, keep only one dot
		s = s.replace(',', '.').replace(/[^\d.]/g, '');
		const firstDot = s.indexOf('.');
		if (firstDot !== -1) {
			s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '');
		}

		// limit to 2 decimals for wishlist while typing
		if (isWishlist && s.includes('.')) {
			const [w, d = ''] = s.split('.');
			s = w + '.' + d.slice(0, 2);
		}

		// clamp to max if it's a valid number
		const n = Number(s);
		if (s !== '' && Number.isFinite(n) && n > maxValue) {
			s = String(maxValue);
		}

		// write back only if changed (prevents cursor jumps)
		if ($this.val() !== s) $this.val(s);

		// update UI
		$(el('valueOverlay')).find('.value').text(s);
	});

	// Optional: on blur, pretty-pad wishlist values to 2 decimals
	$(el('edtVoucherValue')).on('blur', function () {
		const $this = $(this);
		if ($this.closest('.wishlistWrapper').length === 0) return;
		const n = Number(($this.val() || '').toString().replace(',', '.'));
		if (Number.isFinite(n)) {
			const padded = n.toFixed(2);
			if ($this.val() !== padded) $this.val(padded);
			$(el('valueOverlay')).find('.value').text(padded);
		}
	});
	*/

	$(el('mainContainer')).on('click', '#btnOrderVoucher', function()
	{
		addVoucher();
		return false;
	});

	$('.giftvoucherWrapper').on('click', '.voucherImage', function()
	{
		$(el('voucherImage')).find('img').attr('src',$(this).data('url'));
		$(el('edtVoucherImage')).val($(this).data('name'));
	});

	$('.giftvoucherWrapper').on('keyup', '#edtVoucherValue', function()
	{
		$(el('voucherImage')).find('.voucherAmountWrapper .amount').text($(this).val().toString());
	});

	$('.giftvoucherWrapper').on('keyup', '#edtVoucherText', function()
	{
		$(this).val($(this).val().substring(0,280));

		var charCount = parseInt($(this).val().length);
		$(el('frmVoucher')).find('.charCount').html(charCount);
		$(el('voucherImage')).find('.voucherTextWrapper').text($(this).val().toString());
	});

	init();
});

function addVoucher()
{
	var bValid = validateForm($(el('frmVoucher')));

	if(bValid)
	{
		var bWishlist = (typeof sCurrentModule !== "undefined" && sCurrentModule == "wishlist");
		var sParams = getValues($(el('frmVoucher')));

		if (bWishlist)
		{
			sParams += '&id=' + sWishlistId + '&edtVoucherImage=' + sVoucherImage;
		}

		uAjax = (bWishlist) ? "/index.cfm/wishlist/ajax/addegiftvoucher" : "/index.cfm/product/ajax/addegiftvoucher";
		var oCall = callAjax("addegiftvoucher", sParams, "post");
		// process feedback
		oCall.success(function(oData)
		{
			if(oData.ErrorType === '')
			{
				if(bWishlist)
				{
					(bKioskmode) ? $("#mainContainer #viewOnlyWrapper > .wishlistWrapper").replaceWith(oData.html) : $("#mainContainer > .wishlistWrapper").replaceWith(oData.html);
					ciResponsive.process();
				}
				else
				{
					window.location = '/transaction';
				}
			}
			else
			{
				// show error message
				showAlert('error', oData.ErrorMessage, oData.ErrorUnhandled);
			}
		});
	}
}

function init()
{
	$('.voucherImages').find('.voucherImage:first').trigger('click');
}

function isNaturalNumber(n) {
	n = n.toString(); // force the value incase it is not
	var n1 = Math.abs(n),
		n2 = parseInt(n, 10);
	return !isNaN(n1) && n2 === n1 && n1.toString() === n;
}
